import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.option.message !== '')
    ? (_openBlock(), _createElementBlock("aside", {
        key: 0,
        class: _normalizeClass(["block", _ctx.option.type]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, [
        _createElementVNode("p", null, _toDisplayString(_ctx.option.message), 1)
      ], 2))
    : _createCommentVNode("", true)
}